import {combineReducers} from 'redux'
import appReducer from './app/reducer'
import formReducer from './form/reducer'
import portfoliosReducer from './portfolios/reducer'
import uiReducer from './ui/reducer'

export default combineReducers({
  app: appReducer,
  form: formReducer,
  portfolios: portfoliosReducer,
  ui: uiReducer,
})



// WEBPACK FOOTER //
// ./src/store/reducer.js